import TenantActions from './Actions'
import { Chip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 1.5,
    minWidth: 120,
    valueGetter: params => params.row.name || params.value,
  },
  {
    field: 'nombre_completo',
    headerName: 'Nombre Completo',
    headerAlign: 'center',
    flex: 2,
    minWidth: 180,
    valueGetter: params => params.row.fullName || '-',
  },
  {
    field: 'slug',
    headerName: 'Slug',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 100,
  },
  {
    field: 'codigo',
    headerName: 'Código',
    headerAlign: 'center',
    flex: 0.8,
    minWidth: 80,
    valueGetter: params => params.row.code || '-',
  },
  {
    field: 'center_lng',
    headerName: 'Lng',
    headerAlign: 'center',
    flex: 1,
    minWidth: 90,
    type: 'number',
    valueGetter: params => params.row.center?.[0] ?? params.row.center_lng ?? '',
  },
  {
    field: 'center_lat',
    headerName: 'Lat',
    headerAlign: 'center',
    flex: 1,
    minWidth: 90,
    type: 'number',
    valueGetter: params => params.row.center?.[1] ?? params.row.center_lat ?? '',
  },
  {
    field: 'zoom',
    headerName: 'Zoom',
    headerAlign: 'center',
    flex: 0.7,
    minWidth: 60,
    type: 'number',
  },
  {
    field: 'orden',
    headerName: 'Orden',
    headerAlign: 'center',
    flex: 0.7,
    minWidth: 60,
    type: 'number',
  },
  {
    field: 'fecha_registro',
    headerName: 'Registro',
    headerAlign: 'center',
    flex: 1.2,
    minWidth: 120,
    valueGetter: params => {
      const date = params.row.fecha_registro || params.row.createdAt
      return date ? new Date(date).toLocaleDateString() : '-'
    },
  },
  {
    field: 'hasGeojson',
    headerName: 'GeoJSON',
    headerAlign: 'center',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Cargado' : 'Pendiente'}
        color={params.value ? 'info' : 'warning'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    valueGetter: params => params.row.enabled ?? params.row.habilitado,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <TenantActions {...{ params, onEdit, onDelete, onRefresh }} />
    ),
    minWidth: 150,
    flex: 1.5,
  },
]
